// we use it to close popup menu when we pin a view from "More" (because we need to close 2 popovers)
export const BUS_ON_PERSONAL_EVENT_LOCATION_CHANGE = 'bus-on-personal-event-location-change'